<form nz-form nzLayout="vertical" (ngSubmit)="handleOk()">
  <nz-descriptions class="user-header" nzSize="small" [nzBordered]="true" [nzColumn]="1">
    <nz-descriptions-item [nzTitle]="'adminUsers.user' | translate">{{ username }}</nz-descriptions-item>
  </nz-descriptions>

  <nz-form-item>
    <nz-form-label nzRequired>{{ 'changePsd.newPsd' | translate }}</nz-form-label>
    <nz-form-control [nzErrorTip]="psdError">
      <nz-input-password [(nzVisible)]="psdVisible">
        <input nz-input [formControl]="psdControl">
      </nz-input-password>
    </nz-form-control>
    <ng-template #psdError>
      {{ 'changePsd.rules.prefix' | translate }}@for (requirement of requirements(); track requirement.key; let last = $last) {{{ requirement.key | translate: requirement.params }}{{ last ? '' : ', ' }}}
    </ng-template>
  </nz-form-item>
</form>
